import React, { Component } from "react";
import { Link } from "react-router-dom";
// Layout
import Header from "../layout/header/header1";
import bannerImg from "../../images/robotics-for-good/banner.png";
import { withTranslation } from "react-i18next";

class RoboticsForGoodApplication extends Component {
  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
    this.state = {};
  }

  componentDidMount() { }

  render() {
    const { t } = this.props;

    return (
      <>
        <Header />
        <div className="page-content">
          <div className="content-block" id="content-area">
            {/* 🖼️ Banner */}
            <div
              className="page-banner"
              style={{ backgroundImage: `url(${bannerImg})` }}
            >
              <div className="container">
                <div className="page-banner-entry">
                  <h1 className="text-white">{t("Robotics_For_Good_Application_Title")}</h1>
                </div>
              </div>
            </div>

            {/* 🧭 Breadcrumb */}
            <div className="breadcrumb-row">
              <div className="container">
                <ul className="list-inline">
                  <li>
                    <Link to="/">{t("Robotics_For_Good_Application_LinkHome")}</Link>
                  </li>
                  <li>{t("Robotics_For_Good_Application_Link")}</li>
                </ul>
              </div>
            </div>
            {/* 📝 Application Process Section */}
                  <div className="section-full content-inner bg-white m-t30">
                    <div className="container">
                    <div className="section-head style-1 text-center">
                      <h2 className="title">Application Process</h2>
                    </div>
                    <div className="row"></div>
                    <div className="row">
                      <div className="col-lg-12">
                      <h4>🎯 Eligibility</h4>
                      <ul>
                        <li><strong>Junior Category:</strong> Students born 2012–2016 (ages ~9–13)</li>
                        <li><strong>Senior Category:</strong> Students born 2008–2011 (ages ~14–17)</li>
                        <li><strong>Team Size:</strong> Up to 8 members, with at least one coach/mentor (18+)</li>
                        <li><strong>Mixed-age Teams:</strong> Compete in the category of the oldest participant</li>
                        <small>
                          (Coach/mentor must confirm that all team members’ parents/guardians have submitted Form 3.)
                        </small>
                      </ul>
                      <br/>
                      <br/>
                      <h4>📝 Application Process</h4>
                      <h5>Senior Team (ages 14–17):</h5>
                      <ul>
                        <li>
                        Teams submit an application before 25th November, 2025 &rarr; Apply here:&nbsp;
                        <a
                          target="_blank"
                          style={{textDecoration: "underline"}}
                          rel="noopener noreferrer"
                          href="https://docs.google.com/forms/d/e/1FAIpQLSe7UbAeK-2_UrKrLRtaUchsIo9cMHpvCsR_14M1BJwJLzu46A/viewform?usp=dialog"
                        >
                          Form 1 – Senior Team Application
                        </a>
                        </li>
                        <li>
                        One Senior Team of each state will be selected by the end of November 2025.
                        </li>
                        <li>
                        Shortlisted teams will be provided the task sheet to Join the National Final on 25.
                        </li>
                        <li>
                        Parent/Guardian consent is mandatory:&nbsp;
                        <a
                          target="_blank"
                          style={{textDecoration: "underline"}}
                          rel="noopener noreferrer"
                          href="https://docs.google.com/forms/d/e/1FAIpQLSdDYTcSEFFeZzfectAnGfbfIVeGOK856Nmit-jSyVf5HtdAfw/viewform?usp=dialog"
                        >
                          Form 3 – Parental/Guardian Consent
                        </a>
                        <br />
                        <small>
                          (Coach/mentor must confirm that all team members’ parents/guardians have submitted Form 3.)
                        </small>
                        </li>
                      </ul>
                      <h5>Junior Team (ages 9–13):</h5>
                      <ul>
                        <li>
                        Teams submit an application before 25th November, 2025 &rarr; Apply here:&nbsp;
                        <a
                          target="_blank"
                          style={{textDecoration: "underline"}}
                          rel="noopener noreferrer"
                          href="https://docs.google.com/forms/d/e/1FAIpQLSdIZgZH-yVb-tk06b8EI4AokAyKCSdyehe4O09auaUS_wy7oQ/viewform?usp=dialog"
                        >
                          Form 2 – Junior Team Application
                        </a>
                        </li>
                        <li>
                        One Junior Team of each state will be selected by the end of November 2025.
                        </li>
                        <li>
                        Shortlisted teams will be provided the task sheet to Join the National Final on 28th March, 2026.
                        </li>
                        <li>
                        Parent/Guardian consent is mandatory for each student:&nbsp;
                        <a
                          target="_blank"
                          style={{textDecoration: "underline"}}
                          rel="noopener noreferrer"
                          href="https://docs.google.com/forms/d/e/1FAIpQLSdDYTcSEFFeZzfectAnGfbfIVeGOK856Nmit-jSyVf5HtdAfw/viewform?usp=dialog"
                        >
                          Form 3 – Parental/Guardian Consent
                        </a>
                        <br />
                        <small>
                          (Coach/mentor must confirm that all team members’ parents/guardians have submitted Form 3.)
                        </small>
                        </li>
                      </ul>
                      <br/>
                      <br/>
                      <h4>AU National Competition Entry</h4>
                      <p>All state-selected Junior and Senior teams will compete in the Australian National Competition on <strong>28th March, 2026</strong>, hosted at <strong>Glenunga International High School, Adelaide</strong>.</p>
                      <br/>
                      <br/>
                      <h4>📌 Notes</h4>
                      <ul>
                        <li>✅ There is no participation fee.</li>
                        <li>✅ Teams must provide their own robotics kits.</li>
                        <li>✅ All participants must complete media & image rights consent as part of the forms.</li>
                        <li>✈️ Travel, visas, and accommodation for the Global Finale (Geneva, July 2026) are self-funded (sponsorship support may be available).</li>
                       </ul>
                      <br/>
                      <br/>
                      <h4 className="m-t30">📥 Quick Links</h4>
                      <div className="d-flex flex-column gap-3 m-t10" style={{maxWidth: 400}}>
                        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/forms/d/e/1FAIpQLSe7UbAeK-2_UrKrLRtaUchsIo9cMHpvCsR_14M1BJwJLzu46A/viewform?usp=dialog" className="btn btn-primary radius-xl m-lr10" style={{width: "100%", minWidth: 0}}>
                        👉 Form 1 – Senior Team Application
                        </a>
                        <br/>
                        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/forms/d/e/1FAIpQLSdIZgZH-yVb-tk06b8EI4AokAyKCSdyehe4O09auaUS_wy7oQ/viewform?usp=dialog" className="btn btn-success radius-xl m-lr10" style={{width: "100%", minWidth: 0}}>
                        👉 Form 2 – Junior Team Application
                        </a>
                        <br/>
                        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/forms/d/e/1FAIpQLSdDYTcSEFFeZzfectAnGfbfIVeGOK856Nmit-jSyVf5HtdAfw/viewform?usp=dialog" className="btn btn-outline-dark radius-xl m-lr10" style={{width: "100%", minWidth: 0}}>
                        👉 Form 3 – Parental/Guardian Consent
                        </a>
                      </div>
                      </div>
                    </div>
                    </div>
                  </div>
                  {/* END How to Apply */}
          </div>
        </div>
      </>
    );
  }
}

export default RoboticsForGoodApplication = withTranslation()(RoboticsForGoodApplication);
